<template>
  <div>
    <div class="wraper" v-if="!isProjectLoading">
      <div class="container-fluid mycontainer-fluid">
        <slot name="header"></slot>
        <ProjectHeader :title="headerTitle" :excel-org-id="oID"></ProjectHeader>
      </div>
      <div class="container-fluid mycontainer-fluid content">
        <div class="gp-f-tabs">
          <router-link
            tag="button"
            type="button"
            class="gp-f-tabs__item"
            :to="{
              name: 'IndicatorsBalance',
              params: { id: $route.params.id }
            }"
          >
            Бухгалтерский баланс
          </router-link>
          <router-link
            tag="button"
            type="button"
            class="gp-f-tabs__item"
            :to="{
              name: 'IndicatorsIncome',
              params: { id: $route.params.id }
            }"
          >
            Отчет о финансовых результатах
          </router-link>
          <router-link
            tag="button"
            type="button"
            class="gp-f-tabs__item gp-f-tabs__item--active"
            :to="{
              name: 'IndicatorsCashflows',
              params: { id: $route.params.id }
            }"
          >
            Отчет о движении денежных средств
          </router-link>
        </div>
        <div class="gp-f-toolbar">
          <label class="gp-f-select">
            <select
              class="gp-f-select__field"
              v-model="activeOrgId"
              @change="loadCashflows(activeOrgId)"
            >
              <option v-for="org in orgs" :key="org.ID" :value="org.ID">
                {{ org.UF_NAME
                }}{{
                  org.UF_IS_OWNER_PROJECT ? ": Заявитель" : ": Поручитель"
                }}
              </option>
            </select>
          </label>
          <div v-if="loaded" class="gp-f-years">
            <label
              v-for="year in years"
              :key="year.UF_YEAR"
              class="gp-f-toggle"
              :class="{ 'gp-f-toggle--disabled': year.UF_YEAR === currentYear }"
            >
              <input
                type="checkbox"
                class="gp-f-toggle__input"
                :disabled="year.UF_YEAR === currentYear"
                @click="showTable = false"
                @change="showTable = true"
                v-model="year.IS_ACTIVE"
              />
              <span class="gp-f-toggle__slider"></span>
              <span class="gp-f-toggle__label">{{ year.UF_YEAR }}</span>
            </label>
          </div>
          <div v-if="loaded" class="gp-f-toolbar__checkbox">
            <label
              ><input
                type="checkbox"
                v-model="curOrg.UF_IS_NOT_FINANCE_OTCH"
                @change="setIsNotFinance"
              />
              <strong>Отсутствует отчетность</strong></label
            ><br />
            Поставьте галочку, если у компании отсутствует финансовая отчетность
          </div>
        </div>

        <div v-if="loaded">

          <section
            v-if="showTable"
            class="gp-f-report gp-f-report--primary"
            :style="reportStyle"
          >
            <div class="gp-f-report__head">
              <div class="gp-f-report__title">
                <span class="gp-f-report__title-main"
                  >ОТЧЕТ О ДВИЖЕНИИ ДЕНЕЖНЫХ СРЕДСТВ,</span
                >
                <span class="gp-f-report__title-sub">тыс. руб</span>
              </div>
              <div class="gp-f-report__code">
                <span class="gp-f-report__code-line">КОД</span>
                <span class="gp-f-report__code-sub">по приказу № 157</span>
              </div>
              <div class="gp-f-report__years">
                <div class="gp-f-report__years-title">ГОД</div>
                <div class="gp-f-report__years-list">
                  <span
                    v-for="year in activeYears"
                    :key="year.UF_YEAR"
                    class="gp-f-report__year"
                    >{{ year.UF_YEAR }}</span
                  >
                </div>
              </div>
            </div>

            <div class="gp-f-report__body">
              <template v-for="ind in indicators">
                <!-- Заголовок секции (без кода) -->
                <div
                  v-if="!ind.UF_CODE"
                  :key="'section-' + ind.ID"
                  class="gp-f-report__section"
                >
                  {{ ind.UF_NAME }}
                </div>
                <!-- Строка уровня 1 с кодом -->
                <div
                  v-else
                  :key="'row-' + ind.ID"
                  class="gp-f-row"
                  :class="{ 'gp-f-row--total': isNodeAutoCalc(ind) }"
                >
                  <div class="gp-f-row__label">{{ displayName(ind) }}</div>
                  <div class="gp-f-row__code">{{ ind.UF_CODE }}</div>
                  <div
                    v-for="year in activeYears"
                    :key="year.UF_YEAR"
                    class="gp-f-row__values"
                  >
                    <span
                      v-if="isNodeAutoCalc(ind)"
                      class="gp-f-row__value"
                    >{{ calcValue(ind.UF_CODE, year.UF_YEAR) | toCurrencyOO }}</span>
                    <vue-numeric
                      v-else-if="valueMap[ind.ID] && valueMap[ind.ID][year.UF_YEAR] !== undefined"
                      minus="true"
                      :precision="2"
                      separator="space"
                      output-type="Number"
                      v-on:keypress="isNumber($event, true, valueMap[ind.ID][year.UF_YEAR].UF_VALUE)"
                      @change="numberFix(valueMap[ind.ID][year.UF_YEAR], 'UF_VALUE', ind.IS_NEGATIVE)"
                      type="text"
                      class="gp-f-input"
                      v-model="valueMap[ind.ID][year.UF_YEAR].UF_VALUE"
                    />
                  </div>
                </div>

                <!-- Уровень 2: дочерние строки -->
                <template v-for="child in ind.CHILDS || []">
                  <div
                    :key="'child-' + child.ID"
                    class="gp-f-row"
                    :class="{ 'gp-f-row--total': isNodeAutoCalc(child) }"
                  >
                    <div class="gp-f-row__label">{{ displayName(child) }}</div>
                    <div class="gp-f-row__code">{{ child.UF_CODE }}</div>
                    <div
                      v-for="year in activeYears"
                      :key="year.UF_YEAR"
                      class="gp-f-row__values"
                    >
                      <span
                        v-if="isNodeAutoCalc(child)"
                        class="gp-f-row__value"
                      >{{ calcValue(child.UF_CODE, year.UF_YEAR) | toCurrencyOO }}</span>
                      <vue-numeric
                        v-else-if="valueMap[child.ID] && valueMap[child.ID][year.UF_YEAR] !== undefined"
                        minus="true"
                        :precision="2"
                        separator="space"
                        output-type="Number"
                        v-on:keypress="isNumber($event, true, valueMap[child.ID][year.UF_YEAR].UF_VALUE)"
                        @change="numberFix(valueMap[child.ID][year.UF_YEAR], 'UF_VALUE', child.IS_NEGATIVE)"
                        type="text"
                        class="gp-f-input"
                        v-model="valueMap[child.ID][year.UF_YEAR].UF_VALUE"
                      />
                    </div>
                  </div>

                  <!-- Уровень 3: внуки — поля ввода -->
                  <div
                    v-for="(grandchild, gIndex) in child.CHILDS || []"
                    :key="'grandchild-' + grandchild.ID"
                    class="gp-f-row"
                  >
                    <div class="gp-f-row__label">
                      <span v-if="gIndex === 0" class="gp-f-row__label-prefix"
                        >В том числе:</span
                      >
                      {{ displayName(grandchild) }}
                    </div>
                    <div class="gp-f-row__code">{{ grandchild.UF_CODE }}</div>
                    <div
                      v-for="year in activeYears"
                      :key="year.UF_YEAR"
                      class="gp-f-row__values"
                    >
                      <vue-numeric
                        v-if="valueMap[grandchild.ID] && valueMap[grandchild.ID][year.UF_YEAR] !== undefined"
                        minus="true"
                        :precision="2"
                        separator="space"
                        output-type="Number"
                        v-on:keypress="isNumber($event, true, valueMap[grandchild.ID][year.UF_YEAR].UF_VALUE)"
                        @change="numberFix(valueMap[grandchild.ID][year.UF_YEAR], 'UF_VALUE', grandchild.IS_NEGATIVE)"
                        type="text"
                        class="gp-f-input"
                        v-model="valueMap[grandchild.ID][year.UF_YEAR].UF_VALUE"
                      />
                    </div>
                  </div>
                </template>
              </template>
            </div>
          </section>
        </div>
      </div>

      <div class="footer footer-fix">
        <div class="container-fluid mycontainer-fluid">
          <div class="footer-sabmit" v-show="!isLoading">
            <router-link
              tag="button"
              :to="{ name: 'Projects' }"
              class="but-style but-ext"
              >Отмена
            </router-link>
            <button class="but-style but-save" @click="save">
              Сохранить
            </button>
          </div>
          <div class="myfooter">
            <div class="myfooter-frp"></div>
          </div>
        </div>
      </div>
    </div>
    <project-menu></project-menu>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import { FETCH_PROJECT } from "../../store/actions.type";
import ProjectHeader from "@/components/project/partial/ProjectHeader";
import { ProjectsService } from "@/common/api.service";
import ProjectMenu from "@/components/project/partial/ProjectMenu";

Vue.filter("toCurrencyOO", function(value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat("ru-RU", {
    style: "decimal",
    minimumFractionDigits: 2
  });
  return formatter.format(value);
});

const AUTO_CALC_CODES = new Set(["4100", "4200", "4300", "4400", "4500"]);
const NEGATIVE_PARENT_CODES = new Set(["4120", "4220", "4320"]);

export default {
  name: "IndicatorsCashflows",
  title: "Показатели компании",

  components: { ProjectHeader, ProjectMenu },

  computed: {
    headerTitle() {
      if (!this.project || !this.project.ORG_INFO) {
        return "Показатели компании";
      }
      return (
        "Показатели компании / " +
        this.project.ORG_INFO.UF_NAME +
        " (№" +
        this.project.UF_NUMBER +
        ")"
      );
    },
    activeYears() {
      return this.years.filter(y => y.IS_ACTIVE);
    },
    currentYear() {
      return new Date().getFullYear();
    },
    reportStyle() {
      const n = this.activeYears.length || 1;
      const yearCols = new Array(n).fill("140px").join(" ");
      return {
        "--grid-cols": `minmax(0, 1fr) 120px ${yearCols}`,
        "--years-cols": `repeat(${n}, 140px)`,
        "--years-span-end": String(3 + n)
      };
    },
    ...mapGetters(["project", "isProjectLoading", "isLoading"])
  },

  data() {
    return {
      orgs: [],
      activeOrgId: null,
      curOrg: {},
      oID: 0,
      indicators: [],
      years: [],
      valueMap: {},
      loaded: false,
      showTable: true
    };
  },

  methods: {
    isAutoCalc(ufCode) {
      return AUTO_CALC_CODES.has(String(ufCode));
    },

    isNodeAutoCalc(node) {
      return AUTO_CALC_CODES.has(String(node.UF_CODE)) || !!(node.CHILDS && node.CHILDS.length);
    },

    // Для «отрицательных» статей (4120/4220/4320 и их потомки) добавляем
    // пометку «(отрицательное значение)» после названия.
    displayName(node) {
      if (!node) return "";
      if (node.IS_NEGATIVE) {
        return `${node.UF_NAME} (отрицательное значение)`;
      }
      return node.UF_NAME;
    },

    calcValue(ufCode, year) {
      const code = String(ufCode);
      const node = this.findByCode(code);

      // Если у узла есть CHILDS — рекурсивно суммируем их (обработка 4110, 4120, 4210, 4220, 4310, 4320 и т.п.)
      if (node && node.CHILDS && node.CHILDS.length) {
        return parseFloat(
          node.CHILDS.reduce((sum, child) => {
            return sum + this.calcValue(String(child.UF_CODE), year);
          }, 0).toFixed(2)
        );
      }

      // Кросс-сиблинговые формулы для кодов, у которых нет своих CHILDS, но они являются сальдо.
      // Коды 4120/4220/4320 и их потомки хранятся со знаком "-", поэтому сальдо считается сложением.
      switch (code) {
        case "4100":
          return parseFloat(
            (this.calcValue("4110", year) + this.calcValue("4120", year)).toFixed(2)
          );
        case "4200":
          return parseFloat(
            (this.calcValue("4210", year) + this.calcValue("4220", year)).toFixed(2)
          );
        case "4300":
          return parseFloat(
            (this.calcValue("4310", year) + this.calcValue("4320", year)).toFixed(2)
          );
        case "4400":
          return parseFloat(
            (
              this.calcValue("4100", year) +
              this.calcValue("4200", year) +
              this.calcValue("4300", year)
            ).toFixed(2)
          );
        case "4500":
          return parseFloat(
            (
              this.getLeafValue("4450", year) +
              this.calcValue("4400", year) +
              this.getLeafValue("4490", year)
            ).toFixed(2)
          );
        default:
          return this.getLeafValue(ufCode, year);
      }
    },

    getLeafValue(ufCode, year) {
      const node = this.findByCode(ufCode);
      if (!node) return 0;
      if (
        this.valueMap[node.ID] &&
        this.valueMap[node.ID][year] !== undefined
      ) {
        let v = parseFloat(this.valueMap[node.ID][year].UF_VALUE) || 0;
        // «Отрицательные» поля всегда участвуют в расчёте сальдо со знаком минус,
        // даже если пользователь только что ввёл положительное число и ещё не снял фокус.
        if (node.IS_NEGATIVE) {
          v = -Math.abs(v);
        }
        return v;
      }
      return 0;
    },

    markNegativeNodes() {
      const mark = (node, parentIsNegative) => {
        const isNeg =
          parentIsNegative ||
          NEGATIVE_PARENT_CODES.has(String(node.UF_CODE));
        Vue.set(node, "IS_NEGATIVE", isNeg);
        for (const child of node.CHILDS || []) {
          mark(child, isNeg);
        }
      };
      for (const ind of this.indicators) {
        mark(ind, false);
      }
    },

    flipNegativeValues() {
      const flipNode = node => {
        if (node.IS_NEGATIVE && this.valueMap[node.ID]) {
          for (const year in this.valueMap[node.ID]) {
            const entry = this.valueMap[node.ID][year];
            if (entry && entry.UF_VALUE > 0) {
              entry.UF_VALUE = -entry.UF_VALUE;
            }
          }
        }
        for (const child of node.CHILDS || []) {
          flipNode(child);
        }
      };
      for (const ind of this.indicators) {
        flipNode(ind);
      }
    },

    findByCode(ufCode) {
      const code = String(ufCode);
      for (const ind of this.indicators) {
        if (String(ind.UF_CODE) === code) return ind;
        for (const child of (ind.CHILDS || [])) {
          if (String(child.UF_CODE) === code) return child;
          for (const grandchild of (child.CHILDS || [])) {
            if (String(grandchild.UF_CODE) === code) return grandchild;
          }
        }
      }
      return null;
    },

    async loadOrgs() {
      await ProjectsService.getListIndicatorsOrgs(this.project.ID).then(
        ({ data }) => {
          this.orgs = data.items || [];
          if (this.orgs.length === 0) return;
          const owner = this.orgs.find(o => o.UF_IS_OWNER_PROJECT);
          const initial = owner || this.orgs[0];
          this.activeOrgId = initial.ID;
          this.loadCashflows(initial.ID);
        },
        this
      );
    },

    async loadCashflows(orgId) {
      this.loaded = false;
      this.activeOrgId = orgId;
      this.oID = orgId;
      const found = this.orgs.find(o => o.ID === orgId);
      this.curOrg = found || {};
      await ProjectsService.getCashflowsByCompany(orgId).then(({ data }) => {
        this.indicators = data.indicators || [];
        this.markNegativeNodes();

        const prevYear = new Date().getFullYear() - 1;
        const yearArr = data.yearAr || data.years || [];
        this.years = yearArr.map(y => {
          const yearVal = typeof y === "object" && y !== null ? y.UF_YEAR : y;
          return {
            UF_YEAR: yearVal,
            IS_ACTIVE: yearVal === prevYear
          };
        });

        this.valueMap = {};
        const items = data.items || {};
        for (const cfId in items) {
          Vue.set(this.valueMap, cfId, {});
          for (const year in items[cfId]) {
            const src = items[cfId][year] || {};
            const rawVal = src.UF_INDICATORS_VALUE;
            Vue.set(this.valueMap[cfId], year, {
              ID: src.ID || 0,
              UF_CF_ID: src.UF_INDICATORS_CASHFLOWS_ID || Number(cfId),
              UF_YEAR: src.UF_YEAR || Number(year),
              UF_VALUE:
                rawVal === null || rawVal === undefined || rawVal === ""
                  ? 0
                  : parseFloat(rawVal) || 0
            });
          }
        }

        this.initValueMap();
        this.flipNegativeValues();
        this.loaded = true;
        this.showTable = true;
      }, this);
    },

    initValueMap() {
      const years = this.years.map(y => y.UF_YEAR);

      const initNode = node => {
        if (node.CHILDS && node.CHILDS.length) {
          for (const child of node.CHILDS) {
            initNode(child);
          }
          return;
        }
        if (AUTO_CALC_CODES.has(String(node.UF_CODE))) return;

        if (!this.valueMap[node.ID]) {
          Vue.set(this.valueMap, node.ID, {});
        }
        for (const year of years) {
          if (this.valueMap[node.ID][year] === undefined) {
            Vue.set(this.valueMap[node.ID], year, {
              ID: 0,
              UF_VALUE: 0,
              UF_CF_ID: node.ID,
              UF_YEAR: year
            });
          }
        }
      };

      for (const ind of this.indicators) {
        initNode(ind);
      }
    },

    async save() {
      const items = {};
      for (const cfId in this.valueMap) {
        items[cfId] = {};
        for (const year in this.valueMap[cfId]) {
          const entry = this.valueMap[cfId][year];
          items[cfId][year] = {
            ...entry,
            UF_INDICATORS_VALUE: entry.UF_VALUE
          };
        }
      }
      await ProjectsService.setCashflowsByCompany(this.activeOrgId, {
        items
      }).then(({ data }) => {
        if (data && data.error) {
          (data.errorAr || []).forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        } else {
          this.$toasted.show("Данные сохранены", {
            theme: "green",
            position: "bottom-right",
            duration: 3000
          });
        }
      }, this);
    },

    async setIsNotFinance() {
      await ProjectsService.setIsNotFinance(
        this.oID,
        this.project ? this.project.UF_STATUS_ID : null,
        {
          UF_IS_NOT_FINANCE_OTCH: this.curOrg.UF_IS_NOT_FINANCE_OTCH
        }
      ).then(({ data }) => {
        if (!data.error) {
          console.log("1");
        }
      }, this);
    },

    numberFix(o, k, forceNegative) {
      let val = new String(o[k]);
      let l = val.split(".");
      if (l.length > 1) {
        if (l[1].length > 2) {
          o[k] = parseFloat(val);
        }
      }
      if (forceNegative && o[k] > 0) {
        o[k] = -o[k];
      }
    },

    isNumber(evt, isMinus, val) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode === 46 &&
        typeof val !== "undefined" &&
        String(val).indexOf(".") !== -1
      ) {
        evt.preventDefault();
        return false;
      }
      if (
        charCode === 45 &&
        typeof val !== "undefined" &&
        String(val).indexOf("-") !== -1
      ) {
        evt.preventDefault();
        return false;
      }
      if (charCode === 46) return true;
      if (isMinus && charCode === 45 && evt.target.selectionStart === 0) {
        return true;
      }
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  },

  async created() {
    await this.$store.dispatch(FETCH_PROJECT, this.$route.params.id);
    await this.loadOrgs();
  }
};
</script>

<style scoped>
/* ===== Tabs ===== */
.gp-f-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}

.gp-f-tabs__item {
  appearance: none;
  font-family: inherit;
  font-size: 13px;
  color: #2c2c2c;
  background: #ffffff;
  border: 1px solid #cfd2d5;
  border-radius: 3px;
  padding: 7px 14px;
  cursor: pointer;
  outline: none;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    color 0.15s ease;
}

.gp-f-tabs__item:hover {
  border-color: #2b86d0;
  color: #2b86d0;
}

.gp-f-tabs__item--active,
.gp-f-tabs__item--active:hover {
  background: #2676b7;
  border-color: #2676b7;
  color: #ffffff;
  cursor: default;
}

/* ===== Toolbar ===== */
.gp-f-toolbar {
  display: flex;
  align-items: center;
  gap: 32px;
  padding: 14px 10px;
  background: #ffffff;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 16px;
}

.gp-f-select {
  position: relative;
  display: inline-block;
  min-width: 260px;
}

.gp-f-select__field {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 100%;
  padding: 7px 32px 7px 12px;
  font-family: inherit;
  font-size: 13px;
  color: #2c2c2c;
  background: #ffffff;
  border: 1px solid #cfd2d5;
  border-radius: 3px;
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.gp-f-select__field:focus {
  border-color: #2b86d0;
  box-shadow: 0 0 0 2px rgba(43, 134, 208, 0.15);
}

.gp-f-select::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 12px;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 5px solid #2c2c2c;
  transform: translateY(-50%);
  pointer-events: none;
}

.gp-f-years {
  display: flex;
  align-items: center;
  gap: 18px;
}

.gp-f-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
  margin: 0;
  font-weight: normal;
}

.gp-f-toggle__input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}

.gp-f-toggle__slider {
  position: relative;
  display: inline-block;
  width: 32px;
  height: 18px;
  background: #d1d5da;
  border-radius: 999px;
  transition: background-color 0.2s ease;
  flex-shrink: 0;
}

.gp-f-toggle__slider::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  background: #ffffff;
  border-radius: 50%;
  transition: transform 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.gp-f-toggle__input:checked + .gp-f-toggle__slider {
  background: #2b86d0;
}

.gp-f-toggle__input:checked + .gp-f-toggle__slider::after {
  transform: translateX(14px);
}

.gp-f-toggle__label {
  font-size: 13px;
  color: #2c2c2c;
}

.gp-f-toggle--disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.gp-f-toggle--disabled .gp-f-toggle__slider {
  background: #d1d5da;
}

.gp-f-toggle--disabled .gp-f-toggle__label {
  color: #8a8a8a;
}

/* ===== Checkbox (noDebt) ===== */
.gp-f-toolbar__checkbox {
  margin-left: auto;
}

.gp-f-checkbox {
  display: inline-flex;
  gap: 10px;
  align-items: flex-start;
  cursor: pointer;
  user-select: none;
  margin: 0;
  font-weight: normal;
}

.gp-f-checkbox__input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.gp-f-checkbox__box {
  position: relative;
  width: 16px;
  height: 16px;
  border: 1px solid #b4b8bc;
  background: #ffffff;
  border-radius: 2px;
  flex-shrink: 0;
  margin-top: 1px;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.gp-f-checkbox__input:checked + .gp-f-checkbox__box {
  background: #2b86d0;
  border-color: #2b86d0;
}

.gp-f-checkbox__input:checked + .gp-f-checkbox__box::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 1px;
  width: 5px;
  height: 9px;
  border: solid #ffffff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.gp-f-checkbox__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.gp-f-checkbox__title {
  font-size: 13px;
  color: #2c2c2c;
  line-height: 1.3;
  font-weight: 700;
}

.gp-f-checkbox__hint {
  font-size: 11px;
  color: #8a8a8a;
  line-height: 1.3;
}

/* ===== Report ===== */
.gp-f-report {
  display: flex;
  flex-direction: column;
}

.gp-f-report__head,
.gp-f-row {
  display: grid;
  grid-template-columns: var(--grid-cols);
  align-items: center;
  gap: 0;
}

.gp-f-report__head {
  padding: 18px 24px 20px;
  background: #2676b7;
  color: #ffffff;
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 400;
  align-items: end;
  margin-bottom: 20px;
}

.gp-f-report__title {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.01em;
  color: #ffffff;
}

.gp-f-report__title-sub {
  font-weight: 400;
  text-transform: none;
  color: #ffffff;
}

.gp-f-report__code {
  display: flex;
  flex-direction: column;
  font-size: 11px;
  text-transform: none;
  text-align: center;
  line-height: 1.3;
  color: #ffffff;
}

.gp-f-report__code-line {
  text-transform: uppercase;
  font-weight: 400;
  color: #ffffff;
}

.gp-f-report__code-sub {
  font-size: 11px;
  color: #ffffff;
}

.gp-f-report__years {
  grid-column: 3 / var(--years-span-end);
  display: grid;
  grid-template-columns: var(--years-cols);
  justify-items: center;
  text-transform: none;
}

.gp-f-report__years-title {
  grid-column: 1 / -1;
  text-transform: uppercase;
  font-size: 11px;
  margin-bottom: 6px;
  text-align: center;
  width: 100%;
  color: #ffffff;
}

.gp-f-report__years-list {
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: var(--years-cols);
  width: 100%;
}

.gp-f-report__year {
  text-align: center;
  font-size: 12px;
  text-transform: none;
  color: #ffffff;
}

/* Rows */
.gp-f-report__body {
  display: flex;
  flex-direction: column;
}

.gp-f-report__section {
  background: #e9f1f8;
  padding: 12px 24px;
  font-size: 12px;
  color: #2c2c2c;
  border-bottom: 1px solid #f0f0f0;
}

.gp-f-row {
  min-height: 44px;
  padding: 10px 24px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 12px;
  transition: background-color 0.15s ease;
}

.gp-f-row:hover {
  background: #e9f1f8;
}

.gp-f-row__label {
  padding-right: 20px;
  color: #2c2c2c;
  line-height: 1.4;
}

.gp-f-row__label-prefix {
  display: block;
  color: #2c2c2c;
}

.gp-f-row__code {
  text-align: center;
  color: #2c2c2c;
  font-size: 12px;
}

.gp-f-row__values {
  display: flex;
  justify-content: center;
  align-items: center;
}

.gp-f-row__value {
  font-size: 12px;
  color: #2c2c2c;
  text-align: right;
  min-width: 100px;
  padding-right: 16px;
}

.gp-f-row--total {
  background: transparent;
}

/* Input */
.gp-f-input {
  width: 100px;
  padding: 6px 8px;
  font-size: 12px;
  text-align: right;
  color: #2c2c2c;
  border: 1px solid #cfd2d5;
  border-radius: 3px;
  background: #ffffff;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.gp-f-input:focus {
  border-color: #2b86d0;
  box-shadow: 0 0 0 2px rgba(43, 134, 208, 0.15);
}

.gp-f-input::placeholder {
  color: #a0a0a0;
}

@media (max-width: 1200px) {
  .gp-f-input {
    width: 86px;
  }
}
</style>
